export interface iCheckIn {
  // check_in_interface_settings: iCheckInSetting; //签到界面配置
  daily_check_in_settings: iDailyCheckInSetting[]; //每日签到设置
  // is_reset: boolean; //用于每日签到活动 是否重置 false：不重置 true：重置 不重置就是仅修改的意思
  // welfare_task_settings: iWelfareTaskSetting[]; //福利任务设置
  activity_rules: string; //活动规则配置
}
// 签到界面配置
export interface iCheckInSetting {
  activity_main_pic: iPortType; //活动主图
  popup_window_pic: iPortType; //弹窗图
  rule_record_pic: iPortType; //规则/记录图
  button_colors: iButtonCorlor; //按钮色值
}
/* 使用端 */
export interface iPortType {
  android: string;
  pc: string;
}
/* 颜色 */
export interface iButtonCorlor {
  check_in_receive: string; //签到领取色值
  check_in_selected: string; //签到选中色值
  goto_button: string; //去完成/去邀请/去分享色值
  receive_rewards: string; //领取奖励色值
  received: string; //已领取色值
}
/* 每日签到设置 */
export interface iDailyCheckInSetting {
  day_sum?: number;
  day_sum_value?: string;
  reward_type: number; //1、云币 2、体验服时长 3、周期卡 4、现金券
  reward_name: string; //奖品名称
  consumables: number | null; //消耗如reward_type是1，这里则是云币个数，若是2单位就是分钟，若是3、4就是批次号
  adverts_id?: string;
}
/* 福利任务设置 */
export interface iWelfareTaskSetting {
  // task_order_number: string;
  id: string;
  task_type: number;
  task_consumables: string | null;
  frequency: number;
  task_name: string;
  task_explain: string;
  task_prize: iDailyCheckInSetting;
  sort: number;
  task_extend: { security_key: string } | null;
}
export enum eRewardType {
  /**
   * 无
   */
  NO = 0,
  /**
   * 云币
   */
  COIN = 1,
  /**
   * 体验时长
   */
  FREE = 2,
  /**
   * 周期卡
   */
  WEEKCARD = 3,
  /**
   * 现金券
   */
  CASH = 4,
  /* iso */
  IOS = 6,
}
export const RewardTypes = ['选择奖品类型', '云币', '体验时长', '周期卡', '现金券']; //注意：需要和ePrizeType顺序一致

/* 任务类型 1、当日累积付费服连接时长    2、当日累积充值金额    3、穿山甲任务 */
export enum eTaskType {
  NO = 0,
  /*  1、当日累积付费服连接时长*/
  TOTALTIMES = 1,
  /* 2、当日累积充值金额 */
  DAYTOTALMONEY = 2,
  /*   3、穿山甲任务 */
  PANGOLIN = 3,
}
